/*
 * View for the epc area where codes can be added/modified/removed
 * from a topic.  Pretty much like the topicCategoriesView except for the added queue rules
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicResponse/topicAgentAssist/template/topicAgentAssistTemplate.html",
  "modules/topicsSplit/topic/topicResponse/topicAgentAssist/template/topicAgentAssistItemTemplate.html",
], function (Marionette, TopicAgentAssistTemplate, TopicAgentAssistItemTemplate) {
  var TopicAgentAssistView = {};

  TopicAgentAssistView.topicAgentAssistItemView = Marionette.ItemView.extend({
    tagName: "tr",
    template: TopicAgentAssistItemTemplate,
    modelEvents: {
      change: "render",
    },
    triggers: {
      "click #epcDelete": "delete",
      "click #categoryEdit": "edit:category",
      "click #codeEdit": "edit:code",
    },
  });

  TopicAgentAssistView.topicAgentAssistView = Marionette.CompositeView.extend({
    itemView: TopicAgentAssistView.topicAgentAssistItemView,
    itemViewContainer: "tbody",
    template: TopicAgentAssistTemplate,
    triggers: {
      "click #addEpcMigration": "add:code",
    },
  });

  return TopicAgentAssistView;
});
